import React, { useContext, useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import logo from "src/Assets/images/LandingPageImages/skopic-image.png";
import settingsStyles from "src/Assets/css/settings/settings.module.css";

import Notifications from "src/pages/Notifications";
import HeaderAfterSignIn from "../../Components/Header/header";
import Cookies from "js-cookie";
import { CommunityContext } from "src/context/CommunityContext/CommunityContext.js";
import API from "../../network";
import "./index.css";
import { useSelector } from "react-redux";

function TermsofService() {
  return (
    <div className="container content-container" style={{ marginTop: "50px" }}>
      <div className="innercontainer">
        <div className="main-heading-container">
          <h3 className="main-heading">Terms Of Service</h3>
        </div>
        <div className={settingsStyles.TermsofService}>
          <b>These Services are operated and provided by Skopic Inc.</b>
          <br />
          <br />
          These Terms of Service (“Terms”) govern your access to and use of the
          services and Skopic’s websites (the “Services”), and any information,
          text, graphics, photos or other materials uploaded, downloaded or
          appearing on the Services (collectively referred to as “Content”).
          Your access to and use of the Services is conditioned on your
          acceptance of and compliance with these Terms. By accessing or using
          the Services you agree to be bound by these Terms. By “use” we mean
          access, use, copy, publicly perform or display, distribute, modify,
          translate, and create derivative works of.
          <br />
          <br />
          <b>Basic Terms</b>
          <br />
          You are responsible for your use of the Services, for any Content you
          post to the Services, and for any consequences thereof. The Content
          you submit, post, or display will be able to be viewed by other users
          of the Services and through third party services and websites. You
          should only provide Content that you are comfortable sharing with
          others under these Terms.
          <br />
          <br />
          Thus, what you say on Skopic may be viewed all around the world
          instantly.
          <br />
          <br />
          You may use the Services only if you can form a binding contract with
          Skopic and are not a person barred from receiving services under the
          laws of the United States or other applicable jurisdiction. You may
          use the Services only in compliance with these Terms and all
          applicable local, state, national, and international laws, rules and
          regulations.
          <br />
          <br />
          The Services that Skopic provides are always evolving and the form and
          nature of the Services that Skopic provides may change from time to
          time without prior notice to you. In addition, Skopic may stop
          (permanently or temporarily) providing the Services (or any features
          within the Services) to you or to users generally and may not be able
          to provide you with prior notice. We also retain the right to create
          limits on use and storage at our sole discretion at any time without
          prior notice to you.
          <br />
          The Services may include advertisements that are targeted through
          queries made through the Services, or other information. The types and{" "}
          extent of advertising by Skopic on the Services are subject to change.
          In consideration for Skopic granting you access to and use of the{" "}
          Services, you agree that Skopic and its third party providers and
          partners may place such advertising on the Services or in connection
          with the display of Content or information from the Services whether
          submitted by you or others.
          <br />
          <br />
          Your continued use of the Services represents full agreement with
          these Terms as they now exist and as they may be amended or changed.
          <br />
          <br />
          <b>Privacy Policy:</b>
          <br />
          Any information that you provide to Skopic is subject to the Privacy
          Policy stated under “Policy” on our website, which governs our
          collection and use of your information. You understand that through
          your use of the Services you consent to the collection and use (as set
          forth in the Privacy Policy) of this information, including the
          transfer of this information to the United States and/or other
          countries for storage, processing and use by Skopic. As part of
          providing you the Services, we may need to provide you with certain
          communications, such as service announcements and administrative
          messages.These communications are considered part of the Services and
          your Skopic account, which you may not be able to opt-out from
          receiving.
          <br />
          <br />
          <b>Passwords</b>
          <br />
          You are responsible for safeguarding the password that you use to
          access the Services and for any activities or actions under your
          password. We encourage you to use “strong” passwords (passwords that
          use a combination of upper and lower case letters, numbers and
          symbols) with your account. Skopic cannot and will not be liable for
          any loss or damage arising from your failure to comply with the above
          requirements.
          <br />
          <br />
          <b>Content on the Services</b>
          <br />
          All Content, whether publicly posted or privately transmitted, is the
          sole responsibility of the person who originated such Content. We may
          not monitor or control the Content posted via the Services and, we
          cannot take responsibility for such Content. Any use or reliance on
          any Content or materials posted via the Services or obtained by you
          through the Services is at your own risk.
          <br />
          <br />
          We do not endorse, support, represent or guarantee the completeness,
          truthfulness, accuracy, or reliability of any Content or
          communications posted via the Services or endorse any opinions
          expressed via the Services. You understand that by using the Services,
          you may be exposed to Content that might be offensive,
          harmful,inaccurate or otherwise inappropriate, or in some cases,
          postings that have been mislabeled or are otherwise deceptive. Under
          no circumstances will Skopic be liable in any way for any Content,
          including, but not limited to, any errors or omissions in any Content,
          or any loss or damage of any kind incurred as a result of the use of
          any Content posted, emailed, transmitted or otherwise made available
          via the Services or broadcast elsewhere.
          <br />
          <br />
          <b>Your Rights</b>
          <br />
          You retain your rights to any Content you submit, post or display on
          or through the Services. By submitting, posting or displaying Content
          on or through the Services,you grant us a worldwide, non-exclusive,
          royalty-free license (with the right to sublicense) to use, copy,
          reproduce, process, adapt, modify, publish, transmit, display and
          distribute such Content in any and all media or distribution methods
          (now known or later developed). Thus, this license authorizes us to
          make your information available to the rest of the world and to let
          others do the same.
          <br />
          <br />
          You agree that this license includes the right for Skopic to make such
          Content available to other companies, organizations or individuals who{" "}
          partner with Skopic for the syndication, broadcast, distribution or
          publication of such Content on other media and services, subject to
          our terms and conditions for such Content use.
          <br />
          <br />
          Skopic has an evolving set of rules for how ecosystem partners can
          interact with your content. Such additional uses by Skopic, or other{" "}
          companies, organizations or individuals who partner with Skopic, may
          be made with no compensation paid to you with respect to the Content{" "}
          that you submit, post, transmit or otherwise make available through
          the Services.
          <br />
          <br />
          We may modify or adapt your Content in order to transmit, display or
          distribute it over computer networks and in various media and/or make{" "}
          changes to your Content as are necessary to conform and adapt that
          Content to any requirements or limitations of any networks, devices,{" "}
          services or media.
          <br />
          <br />
          You are responsible for your use of the Services, for any Content you
          provide, and for any consequences thereof, including the use of your{" "}
          Content by other users and our third party partners. You understand
          that your Content may be rebroadcasted by our partners and if you do
          not have the right to submit Content for such use, it may subject you
          to liability. Skopic will not be responsible or liable for any use of
          your Content by Skopic in accordance with these Terms. You represent
          and warrant that you have all the rights, power and authority
          necessary to grant the rights granted herein to any Content that you
          submit.
          <br />
          <br />
          Skopic gives you a personal, worldwide, royalty-free, non-assignable
          and non-exclusive license to use the software that is provided to you
          by Skopic as part of the Services. This license is for the sole
          purpose of enabling you to use and enjoy the benefit of the Services
          as provided by Skopic, in the manner permitted by these Terms.
          <br />
          <br />
          <b>Skopic Rights</b>
          <br />
          All right, title, and interest in and to the Services (excluding
          Content provided by users) are and will remain the exclusive property
          of Skopic and its licensors. The Services may be protected by
          copyright, trademark, and other laws of both the United States and
          foreign countries. Nothing in the Terms gives you a right to use the
          Skopic name or any Skopic trademark, logo, domain name, and other
          distinctive brand features. Any feedback, comments, or suggestions you
          may provide regarding Skopic, or the Services is entirely voluntary
          and we will be free to use such feedback, comments or suggestions as
          we see fit and without any obligation to you.
          <br />
          <br />
          <b>Restrictions on Content and Use of the Services</b>
          <br />
          We reserve the right at all times (but will not have an obligation) to
          remove or refuse to distribute any Content on the Services and to
          terminate users or reclaim usernames. We also reserve the right to
          access, read, preserve, and disclose any information as we reasonably
          believe is necessary to
          <br />
          (i) satisfy any applicable law, regulation, legal process or
          governmental request,
          <br />
          (ii) enforce the Terms, including investigation of potential
          violations hereof,
          <br />
          (iii) detect, prevent, or otherwise address fraud, security or
          technical issues,
          <br />
          (iv) respond to user support requests, or
          <br />
          (v) protect the rights, property or safety of Skopic, its users and
          the public.
          <br />
          <br />
          <b>
            You may not do any of the following while accessing or using the
            Services:
          </b>
          <br />
          (i) access, tamper with, or use non-public areas of the Services,
          Skopic’s computer systems, or the technical delivery systems of
          Skopic’s providers;
          <br />
          (ii) probe, scan, or test the vulnerability of any system or network
          or breach or circumvent any security or authentication measures;
          <br />
          (iii) access or search or attempt to access or search the Services by
          any means (automated or otherwise) other than through our currently{" "}
          available, published interfaces that are provided by Skopic (and only
          pursuant to those terms and conditions), unless you have been
          specifically allowed to do so in a separate agreement with Skopic
          (NOTE: crawling the Services is permissible if done in accordance with
          the provisions of the robots.txt file, however, scraping the Services
          without the prior consent of Skopic is expressly prohibited);
          <br />
          (iv) forge any TCP/IP packet header or any part of the header
          information in any email or posting, or in any way use the Services to
          send altered, deceptive or false source-identifying information; or
          <br />
          (v) interfere with, or disrupt, (or attempt to do so), the access of
          any user, host or network, including, without limitation, sending a
          virus, overloading, flooding, spamming, mail-bombing the Services, or
          by scripting the creation of Content in such a manner as to interfere
          with or create an undue burden on the Services.
          <br />
          <br />
          <b>Copyright Policy</b>
          <br />
          Skopic respects the intellectual property rights of others and expects
          users of the Services to do the same. We may respond to notices of{" "}
          alleged copyright infringement that comply with applicable law and are
          properly provided to us. If you believe that your Content has been
          copied in a way that constitutes copyright infringement, please
          provide us with the following information:
          <br />
          (i) a physical or electronic signature of the copyright owner or a
          person authorized to act on their behalf;
          <br />
          (ii) identification of the copyrighted work claimed to have been
          infringed;
          <br />
          (iii) identification of the material that is claimed to be infringing
          or to be the subject of infringing activity and that is to be removed
          or access to which is to be disabled, and information reasonably
          sufficient to permit us to locate the material;
          <br />
          (iv) your contact information, including your address, telephone
          number, and an email address;
          <br />
          (v) a statement by you that you have a good faith belief that use of
          the material in the manner complained of is not authorized by the
          copyright owner, its agent, or the law; and
          <br />
          (vi) a statement that the information in the notification is accurate,
          and, under penalty of perjury, that you are authorized to act on
          behalf of the copyright owner.
          <br />
          <br />
          We reserve the right to remove Content alleged to be infringing
          without prior notice and at our sole discretion. In appropriate
          circumstances, Skopic will also terminate a user’s account if the user
          is determined to be a repeat infringer.
          <br />
          <br />
          <b>The Services are Available "AS-IS"</b>
          <br />
          Your access to and use of the Services or any Content is at your own
          risk. You understand and agree that the Services is provided to you on
          an "AS IS" and "AS AVAILABLE" basis. Without limiting the foregoing,
          SKOPIC AND ITS PARTNERS DISCLAIM ANY WARRANTIES, EXPRESS OR IMPLIED,
          OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR
          NON-INFRINGEMENT. We make no warranty and disclaim all responsibility
          and liability for the completeness, accuracy, availability,
          timeliness, security or reliability of the Services or any content
          thereon. Skopic will not be responsible or liable for any harm to your
          computer system, loss of data, or other harm that results from your
          access to or use of the Services, or any Content. You also agree that
          Skopic has no responsibility or liability for the deletion of, or the
          failure to store or to transmit, any Content and other communications
          maintained by the Services. We make no warranty that the Services will
          meet your requirements or be available on an uninterrupted, secure, or
          error-free basis. No advice or information, whether oral or written,
          obtained from Skopic or through the Services, will create any warranty
          not expressly made herein.
          <br />
          <br />
          <b>Limitation of Liability</b>
          <br />
          TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, SKOPIC AND ITS
          SUBSIDIARIES, AFFILIATES, OFFICERS, EMPLOYEES, AGENTS, PARTNERS AND
          LICENSORS WILL NOT BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
          SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, INCLUDING WITHOUT
          LIMITATION, LOSS OF PROFITS, DATA, USE, GOOD-WILL, OR OTHER INTANGIBLE
          LOSSES, RESULTING FROM
          <br />
          (i) YOUR ACCESS TO OR USE OF OR INABILITY TO ACCESS OR USE THE
          SERVICES;
          <br />
          (ii) ANY CONDUCT OR CONTENT OF ANY THIRD PARTY ON THE SERVICES,
          INCLUDING WITHOUT LIMITATION, ANY DEFAMATORY, OFFENSIVE OR ILLEGAL
          CONDUCT OF OTHER USERS OR THIRD PARTIES;
          <br />
          (iii) ANY CONTENT OBTAINED FROM THE SERVICES; AND
          <br />
          (iv) UNAUTHORIZED ACCESS, USE OR ALTERATION OF YOUR TRANSMISSIONS OR
          CONTENT, WHETHER BASED ON WARRANTY, CONTRACT, TORT (INCLUDING
          NEGLIGENCE) OR ANY OTHER LEGAL THEORY, WHETHER OR NOT SKOPIC HAS BEEN
          INFORMED OF THE POSSIBILITY OF SUCH DAMAGE, AND EVEN IF A REMEDY SET
          FORTH HEREIN IS FOUND TO HAVE FAILED OF ITS ESSENTIAL PURPOSE.
          <br />
          <br />
          <b>Waiver and Severability</b>
          <br />
          The failure of Skopic to enforce any right or provision of these Terms
          will not be deemed a waiver of such right or provision. In the event
          that any provision of these Terms is held to be invalid or
          unenforceable, the remaining provisions of these Terms will remain in
          full force and effect.
          <br />
          <br />
          <b>Links</b>
          The Services may contain links to third-party websites or resources.
          You acknowledge and agree that we are not responsible or liable for:
          <br />
          (i) the availability or accuracy of such websites or resources; or
          <br />
          (ii) the content, products, or services on or available from such
          websites or resources. Links to such websites or resources do not
          imply any endorsement by Skopic of such websites or resources or the
          content, products, or services available from such websites or
          resources. You acknowledge sole responsibility for and assume all risk
          arising from your use of any such websites or resources.
          <br />
          <br />
          <b>Controlling Law and Jurisdiction</b>
          <br />
          These Terms and any action related thereto will be governed by the
          laws of the State of California without regard to or application of
          its conflict of law provisions or your state or country of residence.
          All claims, legal proceedings or litigation arising in connection with
          the Services will be brought solely in Santa Clara County, California,
          and you consent to the jurisdiction of and venue in such courts and
          waive any objection as to inconvenient forum. If you are accepting
          these Terms on behalf of a United States federal government entity
          that is legally unable to accept the controlling law, jurisdiction or
          venue clauses above, then those clauses do not apply to you but
          instead these Terms and any action related thereto will be will be
          governed by the laws of the United States of America (without
          reference to conflict of laws) and, in the absence of federal law and
          to the extent permitted under federal law, the laws of the State of
          California (excluding choice of law).
          <br />
          <br />
          <b>Safety</b>
          <br />
          We do our best to keep Skopic safe, but we cannot guarantee it. We
          need your help to do that, which includes the following commitments:
          <br />
          1. You will not send or otherwise post unauthorized commercial
          communications (such as spam) on Skopic.
          <br />
          2. You will not collect users' content or information, or otherwise
          access Skopic, using automated means (such as harvesting bots, robots,
          spiders, or scrapers) without our permission.
          <br />
          3. You will not engage in unlawful multi-level marketing, such as a
          pyramid scheme, on Skopic.
          <br />
          4. You will not upload viruses or other malicious code.
          <br />
          5. You will not solicit login information or access an account
          belonging to someone else.
          <br />
          6. You will not bully, intimidate, or harass any user.
          <br />
          7. You will not post content that: is hateful, threatening, or
          pornographic; incites violence; or contains nudity or graphic or
          gratuitous violence.
          <br />
          8. You will not develop or operate a third-party application
          containing alcohol-related or other mature content (including
          advertisements) without appropriate age-based restrictions.
          <br />
          9. You will not use Skopic to do anything unlawful, misleading,
          malicious, or discriminatory.
          <br />
          10. You will not do anything that could disable, overburden, or impair
          the proper working of Skopic, such as a denial of service attack.
          <br />
          11. You will not facilitate or encourage any violations of this
          agreement.
          <br />
          <br />
          <b>Registration and Account Security</b>
          <br />
          Skopic users provide their real names and information, and we need
          your help to keep it that way. Here are some commitments you make to
          us relating to registering and maintaining the security of your
          account:
          <br />
          1. You will not provide any false personal information on Skopic, or
          create an account for anyone other than yourself without permission.
          <br />
          2. You will not create more than one personal profile.
          <br />
          3. If we disable your account, you will not create another one without
          our permission.
          <br />
          4. You will not use your personal profile for your own commercial gain
          (such as selling your status update to an advertiser).
          <br />
          5. You will not use Skopic if you are under 13.
          <br />
          6. You will not use Skopic if you are a convicted sex offender.
          <br />
          7. You will keep your contact information accurate and up-to-date.
          <br />
          8. You will not share your password, (or in the case of developers,
          your secret key), let anyone else access your account, or do anything
          else that might jeopardize the security of your account.
          <br />
          9. You will not transfer your account (including any page or
          application you administer) to anyone without first getting our
          written permission.
          <br />
          10. If you select a username for your account we reserve the right to
          remove or reclaim it if we believe appropriate (such as when a
          trademark owner complains about a username that does not closely
          relate to a user's actual name).
          <br />
          <br />
          <b>Protecting Other People's Rights</b>
          <br />
          We respect other people's rights, and expect you to do the same.
          <br />
          1. You will not post content or take any action on Skopic that
          infringes or violates someone else's rights or otherwise violates the
          law.
          <br />
          2. We can remove any content or information you post on Skopic if we
          believe that it violates this Statement.
          <br />
          3. If you repeatedly infringe other people's intellectual property
          rights, we will disable your account when appropriate.
          <br />
          4. You will not use our intellectual property, copyrights or
          trademarks or any confusingly similar marks, without our written
          permission.
          <br />
          5. If you collect information from users, you will: obtain their
          consent, make it clear you (and not Skopic) are the one collecting
          their information, and post a privacy policy explaining what
          information you collect and how you will use it.
          <br />
          6. You will not post anyone's identification documents or sensitive
          financial information on Skopic.
          <br />
          7. You will not tag users or send email invitations to non-users
          without their consent.
          <br />
          <br />
          <b>Special Developers/Operators Provisions</b>
          <br />
          If you are a developer or operator of Skopic, the following additional
          terms apply to you:
          <br />
          1. You are responsible for your application and its content and all
          uses you make of Skopic. This includes ensuring your application or
          use of Skopic meets the terms of this agreement.
          <br />
          2. Your access to and use of data you receive from Skopic, will be
          limited as follows:
          <br />
          1. You will only request data you need to operate your application.
          <br />
          2. You will have a privacy policy that tells users what user data you
          are going to use and how you will use, display, share, or transfer
          that data.
          <br />
          3. You will not use, display, share, or transfer a user’s data in a
          manner inconsistent with your privacy policy.
          <br />
          4. You will delete all data you receive from us concerning a user if
          the user asks you to do so, and will provide a mechanism for users to
          make such a request.
          <br />
          5. You will not include data you receive from us concerning a user in
          any advertising creative.
          <br />
          6. You will not directly or indirectly transfer any data you receive
          from us to (or use such data in connection with) any ad network, ad
          exchange, data broker, or other advertising related toolset, even if a
          user consents to that transfer or use.
          <br />
          7. You will not sell user data. If you are acquired by or merge with a
          third party, you can continue to use user data within your
          application, but you cannot transfer user data outside of your
          application.
          <br />
          8. We can require you to delete user data if you use it in a way that
          we determine is inconsistent with users’ expectations.
          <br />
          9. We can limit your access to data.
          <br />
          10. You will not give us information that you independently collect
          from a user or a user's content without that user's consent.
          <br />
          11. You will make it easy for users to remove or disconnect from your
          application.
          <br />
          12. You will make it easy for users to contact you. We can also share
          your email address with users and others claiming that you have
          infringed or otherwise violated their rights.
          <br />
          13. You will provide customer support for your application.
          <br />
          14. You will not show third party ads or web search boxes on Skopic.
          <br />
          15. You will not sell, transfer, or sublicense our code, APIs, or
          tools to anyone.
          <br />
          16. You will not misrepresent your relationship with Skopic to others.
          <br />
          17. We can issue a press release describing our relationship with you.
          <br />
          18. You will comply with all applicable laws. In particular you will
          (if applicable):
          <br />
          1. have a policy for removing infringing content and terminating
          repeat infringers that complies with the Digital Millennium Copyright
          Act.
          <br />
          2. comply with the Video Privacy Protection Act (VPPA), and obtain any
          opt-in consent necessary from users so that user data subject to the
          VPPA may be shared on Skopic. You represent that any disclosure to us
          will not be incidental to the ordinary course of your business.
          <br />
          19. We do not guarantee that Skopic will always be free.
          <br />
          20. You give us all rights necessary to enable your application to
          work with Skopic, including the right to incorporate content and
          information you provide to us into streams, profiles, and user action
          stories.
          <br />
          21. You give us the right to link to or frame your application, and
          place content, including ads, around your application.
          <br />
          22. We can analyze your application, content, and data for any
          purpose, including commercial (such as for targeting the delivery of
          <br />
          advertisements and indexing content for search). 23. To ensure your
          application is safe for users, we can audit it.
          <br />
          24. We can create applications that offer similar features and
          services to, or otherwise compete with, your application. Termination
          If you violate the letter or spirit of this agreement, or otherwise
          create risk or possible legal exposure for us, we can stop providing
          all or part of Skopic to you.
          <br />
          <br />
          <b>Disputes</b>
          <br />
          1. You will resolve any claim, cause of action or dispute (claim) you
          have with us arising out of or relating to this agreement or Skopic
          exclusively in a state or federal court located in Santa Clara County.
          The laws of the State of California will govern this Statement, as
          well as any claim that might arise between you and us, without regard
          to conflict of law provisions. You agree to submit to the personal
          jurisdiction of the courts located in Santa Clara County, California
          for the purpose of litigating all such claims.
          <br />
          2. If anyone brings a claim against us related to your actions,
          content or information on Skopic, you will indemnify and hold us
          harmless from and against all damages, losses, and expenses of any
          kind (including reasonable legal fees and costs) related to such
          claim.
          <br />
          3. we try to keep skopic up, bug-free, and safe, but you use it at
          your own risk. we are providing skopic as is without any express or
          implied warranties including, but not limited to, implied warranties
          of merchantability, fitness for a particular purpose, and
          non-infringement. we do not guarantee that skopic will be safe or
          secure. skopic is not responsible for the actions, content,
          information, or data of third parties, and you release us, our
          directors, officers, employees, and agents from any claims and
          damages, known and unknown, arising out of or in any way connected
          with any claim you have against any such third parties. if you are a
          california resident, you waive california civil code §1542, which
          says: a general release does not extend to claims which the creditor
          does not know or suspect to exist in his favor at the time of
          executing the release, which if known by him must have materially
          affected his settlement with the debtor. we will not be liable to you
          for any lost profits or other consequential, special, indirect, or
          incidental damages arising out of or in connection with this statement
          or skopic, even if we have been advised of the possibility of such
          damages. our aggregate liability arising out of this statement or
          skopic will not exceed the greater of one hundred dollars ($100) or
          the amount you have paid us in the past twelve months. applicable law
          may not allow the limitation or exclusion of liability or incidental
          or consequential damages, so the above limitation or exclusion may not
          apply to you. in such cases, skopic's liability will be limited to the
          fullest extent permitted by applicable law.
          <br />
          <br />
          <b>
            Special Provisions Applicable to Users Outside the United States
          </b>
          <br />
          We strive to create a global Community with consistent standards for
          everyone, but we also strive to respect local laws.
          <br />
          <br />
          <b>
            The following provisions apply to users outside the United States:
          </b>
          <br />
          1. You consent to having your personal data transferred to and
          processed in the United States.
          <br />
          2. If you are located in a country embargoed by the United States, or
          are on the U.S. Treasury Department's list of Specially Designated
          Nationals you will not engage in commercial activities on Skopic (such
          as advertising or payments) or operate an application or website.
          <br />
          <br />
          <b>Change of Control</b>
          <br />
          If the ownership of our business changes, we may transfer your
          information to the new owner so they can continue to operate the
          service. But they will still have to honor the commitments we have
          made in this privacy policy.
          <br />
          <br />
          <b>Other</b>
          <br />
          1. You will comply with all applicable laws when using or accessing
          Skopic.
          <br />
          2. If any portion of this Statement is found to be unenforceable, the
          remaining portion will remain in full force and effect.
          <br />
          3. If we fail to enforce any of this Statement, it will not be
          considered a waiver.
          <br />
          4. Any amendment to or waiver of this Statement must be made in
          writing and signed by us.
          <br />
          5. You will not transfer any of your rights or obligations under this
          Statement to anyone else without our consent.
          <br />
          6. All of our rights and obligations under this Statement are freely
          assignable by us in connection with a merger, acquisition, or sale of
          assets, or by operation of law or otherwise.
          <br />
          7. Nothing in this Statement shall prevent us from complying with the
          law.
          <br />
          <br />
          <b>Entire Agreement</b>
          <br />
          These Terms and our Privacy Policy are the entire and exclusive
          agreement between Skopic and you regarding the Services (excluding any
          services for which you have a separate agreement with Skopic that is
          explicitly in addition or in place of these Terms), and these Terms
          supersede and replace any prior agreements between Skopic and you
          regarding the Services. Other than companies of which Skopic is the
          parent or an affiliate, no other person or company will be third party
          beneficiaries to the Terms. We may revise these Terms from time to
          time. By continuing to access or use the Services after those
          revisions become effective, you agree to be bound by the revised
          Terms.
        </div>
      </div>
    </div>
  );
}

function PrivacyPolicyContent() {
  return (
    <div className="container content-container">
      <div className="main-heading-container">
        <h3 className="main-heading">Privacy Policy</h3>
      </div>
      <div className="innercontainer">
        <div className={settingsStyles.TermsofService}>
          <b>Information that is always publicly available</b>
          <br />
          Your user name is always publicly available, and is treated just like
          information you decided to make public.
          <br />
          <br />
          <b>How we use the information we receive</b>
          <br />
          We may use the information we receive about you in connection with the
          services and features we provide to you and other users, the
          advertisers that purchase ads on the site, and the developers that
          build the games, applications, and websites you use.For example, we
          may use the information we receive about you:
          <br />
          <br />
          1. As part of our efforts to keep Skopic safe and secure;
          <br />
          2. To provide you with location features and services;
          <br />
          3. To measure or understand the effectiveness of ads you and others
          see;
          <br />
          4. To make suggestions to you and other users on Skopic.
          <br />
          <br />
          <b>About ASK, SAY and Comments</b>
          <br />
          Skopic pages containing "ASK", "SAY" and comments to those statements
          are public.Companies may use those pages to share information about
          their products.Communities may use pages to discuss topics of
          interest, everything from baseball to the opera.Because these pages
          are public , information you share is public information.This means,
          for example, that if you post a comment, that comment may be used off
          of Skopic, and anyone can see it.As a general rule, you should assume
          that the information will be publicly available.
          <br />
          <br />
          <b>Sharing Information</b>
          <br />
          Skopic may help you share your information with the games,
          applications, and websites you use.Remember that these games,
          applications and websites may be created and maintained by other
          businesses and developers who are not part of Skopic, so you should
          always make sure to read their terms of service and privacy policies.
          <br />
          <br />
          <b>Logging in to another site using Skopic</b>
          <br />
          Skopic may also let you log into other applications and websites using
          your Skopic account.If you already have an account on that website,
          the site may also be able to connect that account with your Skopic
          account.
          <br />
          <br />
          {/* <b>
            Logging in to Skopic using other applications (ex.Facebook, Twitter)
          </b>
          <br />
          Skopic may also let you log in using other applications such as
          Facebook, Twitter if you are a signed user of that website.In such
          situations,
          <br />
          Skopic will have access to your profile information, friends’ network
          and other posts as authorized by you and as per information access
          <br />
          guidelines of that respective service, further Skopic may also post
          and receive updates on your behalf should you choose to do so.However,
          you
          <br />
          will have choice to turn on or off such settings.
          <br /> */}
          <b>Automatic personalization</b>
          <br />
          Skopic may help partners with automatic personalization to create a
          more personalized and social experience.When you visit a site using
          automatic personalization, it may know some information about you and
          your friends and/or acquaintances the moment you arrive.This is
          because automatic personalization sites may have access to your User
          ID, among other things.
          <br />
          <br />
          <b>Public search engines</b>
          <br />
          Your Public Search setting controls whether people who enter your name
          on a public search engine may see your public profile (including in
          sponsored results).
          <br />
          <br />
          <b>Ads</b>
          <br />
          When an advertiser creates an ad on Skopic, they may be given the
          opportunity to choose their audience by location, demographics, likes,
          keywords, and any other information or can tell about you and other
          users.For example, an advertiser can choose to target 18 to 45
          year-old women who live in the United States and like basketball.
          <br />
          If the advertiser chooses to run the ad, we may serve the ad to people
          who meet the criteria the advertiser selected.Advertisers sometimes
          place cookies on your computer in order to make their ads more
          effective.
          <br />
          We may allow advertisers to target a category of user, like a
          "moviegoer" or a "sci-fi fan."
          <br />
          <br />
          <b>Responding to legal requests and preventing harm</b>
          <br />
          We may share your information in response to a legal request (like a
          search warrant, court order or subpoena) if we have a good faith
          belief that the law requires us to do so.This may include responding
          to legal requests from jurisdictions outside of the United States
          where we have a good faith belief that the response is required by law
          in that jurisdiction, affects users in that jurisdiction, and is
          consistent with internationally recognized standards.We may also share
          information when we have a good faith belief it is necessary to
          detect, prevent and address fraud and other illegal activity; and to
          prevent death or imminent bodily harm.
          <br />
          <br />
          <b>Notifications and Other Messages</b>
          <br />
          We may send you notifications and other messages using the contact
          information we have for you, like your email address.You can control
          most of the notifications you receive, including ones from Pages you
          like and applications you use, using your Notifications settings.
          <br />
          <br />
          <b>Cookies</b>
          <br />
          Cookies are small pieces of data that we store on your computer,
          mobile phone or other device to make Skopic easier to use, make our
          advertising better, and to protect you (and Skopic).For example, we
          may use them to know you are logged in to Skopic, to help you use
          social plugins and share buttons, or to know when you are interacting
          with our advertising partners.We may also ask advertisers to serve ads
          to computers, mobile phones or other devices with a cookie placed by
          Skopic (although we would not share any other information with that
          advertiser).Most companies on the web use cookies (or similar
          technological methods), including our advertising partners.You can
          always remove or block cookies (such as by using the settings in your
          browser), but it may affect your ability to use Skopic.
          <br />
          <br />
          <b>Service Providers</b>
          <br />
          We give your information to the people and companies that help us
          provide the services we offer.For example, we may use outside vendors
          to help host our website, serve photos and videos, process payments,
          or provide search results.In some cases we provide the service jointly
          with another company.
          <br />
          <br />
          <b>Registration and Account Security</b>
          <br />
          Skopic users provide their real names and information, and we need
          your help to keep it that way.Here are some commitments you make to us
          relating to registering and maintaining the security of your account:
          <br />
          <br />
          1.You will not provide any false personal information on Skopic, or
          create an account for anyone other than yourself without permission.
          <br />
          2. You will not create more than one personal profile.
          <br />
          3. If we disable your account, you will not create another one without
          our permission.
          <br />
          4. You will not use your personal profile for your own commercial gain
          (such as selling your status update to an advertiser).
          <br />
          5. You will not use Skopic if you are under 13.
          <br />
          6. You will not use Skopic if you are a convicted sex offender.
          <br />
          7. You will keep your contact information accurate and up-to-date.
          <br />
          8. You will not share your password, (or in the case of developers,
          your secret key), let anyone else access your account, or do anything
          else that might jeopardize the security of your account.
          <br />
          9. You will not transfer your account (including any page or
          application you administer) to anyone without first getting our
          written permission.
          <br />
          10. If you select a username for your account we reserve the right to
          remove or reclaim it if we believe appropriate (such as when a
          trademark owner complains about a username that does not closely
          relate to a user's actual name).
          <br />
          <br />
          <b>Protecting Other People's Rights</b>
          <br />
          We respect other people's rights, and expect you to do the same.
          <br />
          <br />
          1. You will not post content or take any action on Skopic that
          infringes or violates someone else's rights or otherwise violates the
          law.
          <br />
          2. We can remove any content or information you post on Skopic if we
          believe that it violates this Statement.
          <br />
          3. If you repeatedly infringe other people's intellectual property
          rights, we will disable your account when appropriate.
          <br />
          4. You will not use our intellectual property, copyrights or
          trademarks or any confusingly similar marks, without our written
          permission.
          <br />
          5. If you collect information from users, you will: obtain their
          consent, make it clear you (and not Skopic) are the one collecting
          their information, and post a privacy policy explaining what
          information you collect and how you will use it.
          <br />
          6. You will not post anyone's identification documents or sensitive
          financial information on Skopic.
          <br />
          7. You will not tag users or send email invitations to non-users
          without their consent.
          <br />
        </div>
      </div>
    </div>
  );
}

function ChildSafetyPolicyContent() {
  return (
    <div className="container content-container">
      <div className="main-heading-container">
        <h3 className="main-heading">Child Safety Policy</h3>
      </div>
      <div className="innercontainer">
        <div className={settingsStyles.TermsofService}>
          <b>Our Commitment</b>
          <br />
          We are committed to creating a safe environment for all users,
          especially children and teenagers. Our platform is designed to prevent
          harm, reduce risk, and respond quickly to any safety concerns
          involving minors. We align our practices with applicable laws and
          recognized safety frameworks, including the Children's Online Privacy
          Protection Act (COPPA) in the United States and the Digital Services
          Act in the European Union.
          <br />
          <br />
          <b>1. Age Requirements</b>
          <br />
          Our platform is strictly intended for users aged 16 years and above.
          We strongly recommend parental consent and oversight for anyone under
          16 years of age if a parent chooses to get their child involved in
          Skopic communities. We may use age verification methods to help ensure
          appropriate access and experiences.
          <br />
          <br />
          <b>2. Prohibited Behavior</b>
          <br />
          We have zero tolerance for behavior that endangers children. This
          includes:
          <br />
          <br />
          1. Child sexual exploitation or abuse content
          <br />
          2. Grooming, predatory behavior, or inappropriate communication with
          minors
          <br />
          3. Sexualization of minors in any form
          <br />
          4. Harassment, bullying, or coercion involving minors
          <br />
          <br />
          Any violation will result in immediate action, including account
          suspension and reporting to relevant authorities.
          <br />
          <br />
          <b>3. Content Moderation & Detection</b>
          <br />
          We use a combination of automated tools and human review to detect and
          remove harmful content. Skopic communities are moderated by active
          community members. Moderators not only can remove any inappropriate
          content but also set rules to approve the content before being
          published. Multiple moderators can be assigned to one community for
          effective oversight and moderation of content.
          <br />
          <br />
          In every Skopic community, moderators are identifiable with a badge
          placed on their avatar image, therefore any member of the community
          can reach out to the moderator using the "Send Email" option available
          in the post (feed) section.
          <br />
          <br />
          If moderators are not responsive for any reason, members can directly
          reach out to Skopic Administrator at{" "}
          <a href="mailto:admin@skopic.com">admin@skopic.com</a>.
          <br />
          <br />
          We continuously improve our moderation systems to better identify
          risks and respond quickly. We are currently evaluating the use of AI
          tools for moderating content at the time of user authoring and for
          already published content.
          <br />
          <br />
          <b>4. Reporting & Response</b>
          <br />
          We provide easy-to-use tools for reporting safety concerns:
          <br />
          <br />
          1. Users can report content or behavior to the community moderator
          directly within the platform. Every user in Skopic community has the
          ability to report regarding a specific post or posts to the community
          moderator should they deem inappropriate in any way.
          <br />
          2. Furthermore, a user has the option within the platform to directly
          email the author of any post should there be any concern regarding the
          content of the post.
          <br />
          3. Reports involving minors are prioritized for urgent review.
          <br />
          <br />
          We take appropriate action, which may include removal of content,
          account suspension, and escalation. Where required, we report illegal
          content to organizations such as the National Center for Missing &
          Exploited Children. We cooperate with law enforcement and child
          protection agencies as required.
          <br />
          <br />
          <b>5. Parental & Guardian Controls</b>
          <br />
          We support parents and guardians by offering:
          <br />
          <br />
          1. Guidance on safe platform use
          <br />
          2. Resources to understand online risks
          <br />
          <br />
          <b>6. Privacy & Data Protection</b>
          <br />
          We limit the collection and use of children's data to what is
          necessary to operate the service safely. The collection of information
          to create an account on Skopic is minimal. Any personal information
          such as address, phone number, gender, occupation etc. are merely
          optional attributes in a user profile.
          <br />
          <br />
          We do not:
          <br />
          <br />
          1. Sell children's personal data
          <br />
          2. Use children's data for targeted advertising where prohibited by
          law
          <br />
          <br />
          <b>7. Safety by Design</b>
          <br />
          We incorporate safety into our platform design by minimizing exposure
          to harmful or inappropriate content:
          <br />
          <br />
          1. The platform does not allow for the posting of video files.
          <br />
          2. The platform does not allow live streaming of any content.
          <br />
          3. The platform does not support video integration feature to
          facilitate video recordings.
          <br />
          4. The platform allows posting of textual messages up to 280
          characters with an option to attach a single file.
          <br />
          5. Only community moderators are allowed to post multiple photos on
          the community timeline, and no video posts are permitted.
          <br />
          <br />
          <b>8. Continuous Improvement</b>
          <br />
          Child safety is an ongoing priority. We regularly:
          <br />
          <br />
          1. Review and update our policies
          <br />
          2. Work with external experts and safety organizations
          <br />
          3. Monitor emerging risks and improve protections
          <br />
          <br />
          <b>9. Contact Us</b>
          <br />
          If you have concerns about child safety on our platform, please
          contact us directly:
          <br />
          <br />
          Email:{" "}
          <a href="mailto:Report_CASE@skopic.com">Report_CASE@skopic.com</a>
          <br />
          Reporting Link: Use the Contact link available at the bottom of{" "}
          <a href="https://www.skopic.com" target="_blank" rel="noreferrer">
            www.skopic.com
          </a>
          , or if using the mobile app, use the contact option in "Help and
          Support" section accessible via the hamburger menu button after
          signing in.
          <br />
        </div>
      </div>
    </div>
  );
}

function PoliciesPage() {
  const [activeSection, setActiveSection] = useState("privacy");
  const privacyRef = useRef(null);
  const childRef = useRef(null);
  const signInStatus = Cookies.get("signInStatus");

  const scrollToSection = (id) => {
    const refMap = { privacy: privacyRef, child: childRef };
    refMap[id]?.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    setActiveSection(id);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { threshold: 0.3 },
    );
    if (privacyRef.current) observer.observe(privacyRef.current);
    if (childRef.current) observer.observe(childRef.current);
    return () => observer.disconnect();
  }, []);

  const navItems = [
    { id: "privacy", label: "Privacy Policy" },
    { id: "child", label: "Child Safety Policy" },
  ];

  return (
    <>
      <style>{`
        .policies-layout {
          display: flex;
          gap: 32px;
          max-width: 1100px;
          margin: 0 auto;
          padding: 32px 24px;
          align-items: flex-start;
        }
        .policies-sidebar {
          width: 220px;
          flex-shrink: 0;
          position: sticky;
          top: 120px;
          align-self: flex-start;
        }
        .policies-sidebar-before-sign-in{
          width: 220px;
          flex-shrink: 0;
          position: sticky;
          top: 80px;
          align-self: flex-start;
        }
        .sidebar-card {
          background: #fff;
          border: 0.5px solid #e5e7eb;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 1px 6px rgba(0,0,0,0.06);
        }
        .sidebar-card-header {
          padding: 13px 16px 11px;
        }
        .sidebar-card-header p {
          font-size: 11px;
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          color: #9ca3af;
          margin: 0;
        }
        .sidebar-divider {
          border: none;
          border-top: 0.5px solid #e5e7eb;
          margin: 0;
        }
        .sidebar-nav-list {
          display: flex;
          flex-direction: column;
        }
        .sidebar-nav-btn {
          display: flex;
          align-items: center;
          gap: 10px;
          width: 100%;
          text-align: left;
          border: none;
          padding: 12px 16px;
          font-size: 13.5px;
          cursor: pointer;
          transition: background 0.15s, color 0.15s;
          outline: none !important;
        }
        .sidebar-nav-btn .dot {
          display: none;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          flex-shrink: 0;
          transition: background 0.15s;
        }
        .sidebar-nav-btn .nav-label {
          flex: 1;
        }
        .sidebar-nav-btn .chevron {
          display: none;
          font-size: 12px;
          opacity: 0.4;
        }
        .sidebar-nav-btn.active {
          background: #EBF3FC;
          color: #185FA5;
          font-weight: 500;
        }
        .sidebar-nav-btn.active .dot {
          background: #185FA5;
        }
        .sidebar-nav-btn:not(.active) {
          background: transparent;
          color: #6b7280;
          font-weight: 400;
        }
        .sidebar-nav-btn:not(.active) .dot {
          background: #d1d5db;
        }
        .sidebar-nav-btn:not(.active):hover {
          background: #f9fafb;
          color: #374151;
        }
        .policies-content {
          flex: 1;
          min-width: 0;
        }
        .policies-content-before-sign-in {
          flex: 1;
          min-width: 0;
          margin-top: -38px;
        }

        /* Tablet */
        @media (max-width: 1023px) {
          .policies-sidebar {
            width: 170px;
          }
          .sidebar-nav-btn {
            font-size: 12.5px;
            padding: 11px 14px;
          }
        }

        /* Mobile */
        @media (max-width: 767px) {
          .policies-layout {
            flex-direction: column;
            gap: 16px;
            padding: 16px;
          }
          .policies-sidebar {
            width: 100%;
            position: static;
            margin-top: 50px;
          }
          .sidebar-card-header {
            display: none;
          }
          .sidebar-divider.top-divider {
            display: none;
          }
          .sidebar-nav-list {
            flex-direction: row;
          }
          .sidebar-nav-btn {
            flex: 1;
            flex-direction: column;
            justify-content: center;
            text-align: center;
            padding: 12px 8px;
            font-size: 12px;
            gap: 5px;
          }
          .sidebar-nav-btn .chevron {
            display: none;
          }
          .sidebar-nav-btn .dot {
            display: none;
            margin: 0 auto;
          }
          .sidebar-divider.mid-divider {
            border: none;
            border-left: 0.5px solid #e5e7eb;
            margin: 0;
          }
        }
      `}</style>

      <div className="container" style={{ marginTop: "50px" }}>
        <div className="policies-layout">
          {/* ── Left Sidebar ── */}
          <aside
            className={
              signInStatus === "true"
                ? "policies-sidebar"
                : "policies-sidebar-before-sign-in"
            }
          >
            <div className="sidebar-card">
              {/* <div className="sidebar-card-header">
                <p>Policies</p>
              </div> */}

              <hr className="sidebar-divider top-divider" />

              <div className="sidebar-nav-list">
                {navItems.map(({ id, label }, index) => (
                  <>
                    <button
                      key={id}
                      onClick={() => scrollToSection(id)}
                      className={`sidebar-nav-btn ${activeSection === id ? "active" : ""}`}
                    >
                      <span className="dot" />
                      <span className="nav-label">{label}</span>
                      <span className="chevron">›</span>
                    </button>

                    {index < navItems.length - 1 && (
                      <hr
                        key={`divider-${id}`}
                        className="sidebar-divider mid-divider"
                      />
                    )}
                  </>
                ))}
              </div>
            </div>
          </aside>

          {/* ── Right Content ── */}
          <main
            className={
              signInStatus === "true"
                ? "policies-content"
                : "policies-content-before-sign-in"
            }
          >
            <section
              id="privacy"
              ref={privacyRef}
              style={{ scrollMarginTop: "80px", marginBottom: "32px" }}
            >
              <PrivacyPolicyContent />
            </section>

            <section
              id="child"
              ref={childRef}
              style={{ scrollMarginTop: "80px", marginBottom: "32px" }}
            >
              <ChildSafetyPolicyContent />
            </section>
          </main>
        </div>
      </div>
    </>
  );
}

function UserGuideLines() {
  return (
    <div className="container content-container" style={{ marginTop: "50px" }}>
      <div className="innercontainer">
        <div className="main-heading-container">
          <h3 className="main-heading">User Guidelines</h3>
        </div>
        <div className={settingsStyles.TermsofService}>
          <p>
            <b>1. Welcome to Skopic</b>
          </p>
          <p>
            We welcome your questions, comments, concerns, and contributions.
            Skopic is designed to connect local communities through a shared
            knowledge network where members can exchange information, share
            thoughts, and ask questions about matters that are relevant to their
            communities.
          </p>
          <p>
            Our goal is to help communities stay informed, connected, and engaged
            through meaningful, timely, and useful information.
          </p>
          <br />

          <p>
            <b>2. Understand Our Terms of Use</b>
          </p>
          <p>
            Please review, understand, and comply with the Terms of Use available
            on the Skopic website and mobile applications.
          </p>
          <br />

          <p>
            <b>3. Contribute Meaningfully</b>
          </p>
          <p>
            Actively participate by sharing timely, relevant, and essential
            information that keeps your community informed and engaged.
          </p>
          <p>
            The more knowledge and insights you contribute, the stronger your
            community's knowledge base becomes. Skopic's Information Networking
            Engine helps members discover relevant information and find answers
            to their questions as the community's knowledge base grows over time.
          </p>
          <br />

          <p>
            <b>4. Keep Content Relevant to Your Community</b>
          </p>
          <p>
            Skopic communities are intended for sharing and discovering useful
            information about local communities and matters of common interest.
          </p>
          <p>
            Please avoid casual conversations, unrelated messages, and content
            that does not serve your community's purpose. Skopic is designed as a
            community information and knowledge-sharing platform, rather than a
            general-purpose social networking or chat platform.
          </p>
          <br />

          <p>
            <b>5. Avoid Continuous Conversations</b>
          </p>
          <p>
            Skopic limits posts to 280 characters and permits one attachment per
            post. Its user interface and information architecture are designed to
            encourage focused information sharing rather than extended,
            back-and-forth conversations.
          </p>
          <p>
            Please keep your contributions concise, informative, and relevant to
            the community.
          </p>
          <br />

          <p>
            <b>6. Use Community UPDATES and #TAGS Responsibly</b>
          </p>
          <p>
            When you publish a Community UPDATE or create a new #TAG, Skopic
            notifies members of your community.
          </p>
          <p>
            Please exercise discretion when creating TAGs or publishing UPDATES.
            Ensure that the content is relevant, timely, and useful before
            notifying your community members.
          </p>
          <br />

          <p>
            <b>7. Be Respectful</b>
          </p>
          <p>
            We are committed to maintaining a community environment that respects
            the dignity of every individual.
          </p>
          <ul style={{ paddingLeft: "20px", marginTop: "10px" }}>
            <li>Express your thoughts and perspectives respectfully.</li>
            <li>
              Avoid personal attacks or confrontational responses to other
              members' posts.
            </li>
            <li>
              Do not post content that is abusive, threatening, harassing, or
              intended to provoke arguments.
            </li>
            <li>
              Keep discussions constructive and focused on sharing information
              and perspectives.
            </li>
          </ul>
          <br />

          <p>
            <b>8. Protect Third-Party Rights</b>
          </p>
          <p>
            Do not post content that infringes upon the rights of any third
            party, including intellectual property, privacy, or publicity rights.
          </p>
          <br />

          <p>
            <b>9. Prohibited Content and Conduct</b>
          </p>
          <p>Do not:</p>
          <ul style={{ paddingLeft: "20px", marginTop: "10px" }}>
            <li>
              Publish inappropriate, unlawful, obscene, defamatory, threatening,
              or harassing content about individuals, groups, organizations, or
              beliefs.
            </li>
            <li>
              Repeatedly publish the same or substantially similar content
              (spam).
            </li>
            <li>
              Post content intended to provoke heated exchanges, debates, or
              arguments.
            </li>
            <li>Impersonate another person.</li>
            <li>
              Allow another person or entity to use your account or credentials
              to post or view content.
            </li>
          </ul>
          <br />

          <p>
            <b>10. Content Visibility and Enforcement</b>
          </p>
          <p>
            Please be aware that your posts are visible to all Skopic users,
            regardless of the communities to which they belong. Other users may
            therefore view or flag your posts if they are found inappropriate.
          </p>
          <p>
            Skopic reserves the right to remove posts that do not comply with
            these Community Guidelines.
          </p>
          <br />

          <p>
            <b>Thank You</b>
          </p>
          <p>
            Thank you for being part of Skopic and helping build a more informed,
            connected, and engaged community.
          </p>
          <p>
            Your contributions make your community's knowledge network stronger.
          </p>
        </div>
      </div>
    </div>
  );
}

function About() {
  return (
    <div className="container content-container" style={{ marginTop: "50px" }}>
      <div className="innercontainer">
        <div className="main-heading-container">
          <h3 className="main-heading">About</h3>
        </div>
        <div className={settingsStyles.TermsofService}>
          <p>
            Most community conversations and information sharing happen in chat
            groups and emails where valuable information quickly gets buried and
            becomes difficult to find. Skopic takes an integrated and structured
            approach to organize all user shared information. Skopic helps
            communities transform everyday thoughts, questions, updates, and
            discussions into a searchable, organized knowledge network. Residents
            can easily find answers, stay informed, and contribute to the
            collective knowledge of the community.
          </p>
          <br />
          <p>
            The community leaders can benefit from better engagement, less
            repetitive communication, and drive a stronger sense of community
            building among members. Best of all, Skopic is free for communities
            and supports unlimited members. Skopic communities maintain
            high-quality, relevant content through built-in moderation mechanisms
            that reduce spam, misinformation, and off-topic discussions.
          </p>
          <br />
          <p>
            Get Skopic today and start engaging in your community to build your
            “Information Network”. It’s quick and easy to Sign-up and start your
            community on Skopic. Skopic is available on Web at{" "}
            <a
              href="https://www.skopic.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#007bff" }}
            >
              www.skopic.com
            </a>
            , and freely downloadable from Google Play Store and Apple Appstore.
          </p>
        </div>
      </div>
    </div>
  );
}

function PrivacyPolicy(props) {
  const type = window.location.pathname.replace("/", "");
  const [signInStatus, setSignInStatus] = useState(null);

  const communityContext = useContext(CommunityContext);
  const settingsData = useSelector((state) => state.voteupReducer.settingsData);

  useEffect(() => {
    window.scrollTo(0, 0);
    const status = Cookies.get("signInStatus");
    setSignInStatus(status);
  }, []);

  let Component = UserGuideLines;
  if (type === "TermsofService") {
    Component = TermsofService;
  } else if (type === "PrivacyPolicy") {
    Component = PoliciesPage;
  } else if (type === "About") {
    Component = About;
  }

  const onSkopicClick = async () => {
    try {
      const response = await API.changeCommunity(
        settingsData?.userTenant,
        settingsData?.userTenantId,
      );
      if (response) {
        communityContext?.onChangeCommunity({
          tenantId: settingsData?.userTenantId,
          tenantName: settingsData?.userTenant,
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  const [isNotificationSelected] = React.useState(false);

  return (
    <div className="footer-main-container">
      {isNotificationSelected ? (
        <div className={`col-sm-3  ${settingsStyles.notifications}`}>
          <div className={settingsStyles.notificationscroll}>
            <Notifications />
          </div>
        </div>
      ) : null}
      <div>
        {signInStatus === "true" ? (
          <HeaderAfterSignIn onSkopicClick={onSkopicClick} />
        ) : (
          <div className={settingsStyles.headerContainer}>
            <div
              onClick={() => (window.location.href = "/")}
              style={{ cursor: "pointer" }}
            >
              <img src={logo} alt="Skopic-Logo" width={90} height={48} />
            </div>
          </div>
        )}
        <Component />
      </div>
    </div>
  );
}

export default PrivacyPolicy;
